import React, { useState, useEffect } from "react";
import UserPageLayout from "../../../../components/UserPageLayout";
import { Link, useParams } from "react-router-dom";
import Loader from "../../../../../../components/Loader";
import Error from "../../../../../error";
import { UserData } from "../../../../network/api/UserData";
import UpdateProfileForm from "./components/UpdateProfileForm";
import { useAppContext } from "../../../../../../context/AppContext";
import Toast from "../../../../../../components/Toast";
import { decodeId } from "../../../../../../utils/hash";
import FileManager from "../../../../components/FileManager";

export default function Profile() {
    const { setPageTitle, setPageUserID } = useAppContext();

    const { id: userID } = useParams();
    const userId = decodeId(userID);


    const [pageLoading, setPageLoading] = useState(false);
    const [pageErrorMessage, setPageErrorMessage] = useState(null);

    const [profile, setProfile] = useState(null);
    const [fileData, setFileData] = useState(null);

    const [toastConfig, setToastConfig] = useState({
        visible: false,
        message: "",
        type: "primary",
    });


    useEffect(() => {
        const fetchProfile = async () => {
            setPageLoading(true);
            setPageErrorMessage(null);

            if (!userId) {
                setPageLoading(false);
                setPageErrorMessage({ code: 401, message: "No user ID found." });
                return;
            }

            try {
                const response = await UserData({ method: "GET", id: userId });

                if (response.status === "success") {
                    setProfile(response.data);
                    //console.log(response.data);
                } else {
                    setPageErrorMessage({ code: response.code, message: response.message });
                }
            } catch (err) {
                setPageErrorMessage({ code: 500, message: err.message || "Failed to load profile." });
            } finally {
                setPageLoading(false);
            }
        };
        setPageUserID(userId);
        fetchProfile();
    }, [userId, setPageUserID]);

    useEffect(() => {
        setPageTitle("Profile");
    }, [setPageTitle]);

    return (
        <UserPageLayout>
            <Toast message={toastConfig.message}
                type={toastConfig.type}
                visible={toastConfig.visible}
                setVisible={(visible) => setToastConfig({ ...toastConfig, visible })}
            />

            <div className="content-body">
                <div className="container-fluid">
                    {profile ?
                        <div className="row page-titles">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item  "><Link to="/users">users</Link></li>
                                <li className="breadcrumb-item  active"><span>Profile</span></li>
                            </ol>
                        </div> : <></>
                    }

                    {pageLoading ? <Loader /> : pageErrorMessage ? <Error code={pageErrorMessage.code} message={pageErrorMessage.message} /> :

                        <>

                            <div className="row">
                                <div className="col-xl-4 ">
                                    <div>
                                        <div className="card overflow-hidden">
                                            <div className="text-center p-3 overlay-box " style={{ backgroundImage: `url(https://t3.ftcdn.net/jpg/07/54/69/58/360_F_754695855_hkDMu3QQ8Yu1kQZbyHHwgokSpmkXqqff.jpg)` }} >
                                                <div className="profile-photo ">
                                                    <img src={profile?.image ? `${profile?.image}` : "https://img.freepik.com/premium-vector/profile-picture-placeholder-avatar-silhouette-gray-tones-icon-colored-shapes-gradient_1076610-40164.jpg"} width="100" className="img-fluid rounded-circle me-3" alt="avatar" 
                                                    style={{ width: "100px",height:"100px", objectFit: "cover", objectPosition: "center" }}
                                                    onError={(e) => { e.target.onerror = null; e.target.src = "https://img.freepik.com/premium-vector/profile-picture-placeholder-avatar-silhouette-gray-tones-icon-colored-shapes-gradient_1076610-40164.jpg"; }} />
                                                </div>
                                                <h3 className="mt-3 mb-1 text-white">
                                                    {profile?.displayname}
                                                    <sup
                                                        className={`badge text-sm ms-2 ${profile?.status === "active"
                                                            ? "badge-success"
                                                            : profile?.status === "pending"
                                                                ? "badge-warning"
                                                                : "badge-danger"
                                                            }`}
                                                        style={{ fontSize: "0.65rem" }}
                                                    >
                                                        {profile?.status}
                                                    </sup>
                                                </h3>
                                                <p className="text-white mb-0">{`user  ${profile?.super ? "/ super " : ""} ${profile?.trusted ? "/ trusted " : ""}`}</p>
                                            </div>
                                            <ul className="list-group list-group-flush">
                                                <li className="list-group-item d-flex justify-content-between"><span className="mb-0">Name</span> <strong className="text-muted">{profile?.fullname}	</strong></li>
                                                <li className="list-group-item d-flex justify-content-between"><span className="mb-0">Email</span> 		<strong className="text-muted">{profile?.email}	</strong></li>
                                                <li className="list-group-item d-flex justify-content-between"><span className="mb-0">Phone</span> 		<strong className="text-muted">{profile?.phone}	</strong></li>
                                                <li className="list-group-item d-flex justify-content-between"><span className="mb-0">Created</span> 		<strong className="text-muted">{profile?.created}	</strong></li>
                                            </ul>

                                            <div className="card-footer pt-0 pb-0 text-center">
                                                <div className="row">
                                                    <div className="col-4 pt-3 pb-3 border-end">
                                                        <h3 className="mb-1 text-primary">{profile?.total_keys - profile?.prev_keys || 0}</h3>
                                                        <span>New</span>
                                                    </div>
                                                    <div className="col-4 pt-3 pb-3 border-end">
                                                        <h3 className="mb-1 text-primary">{profile?.prev_keys || 0}</h3>
                                                        <span>Previous</span>
                                                    </div>
                                                    <div className="col-4 pt-3 pb-3">
                                                        <h3 className="mb-1 text-primary">{profile?.total_keys || 0}</h3>
                                                        <span>Total Keys</span>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="col-xl-12">
                                        <FileManager ownerId={profile?.id} fileData={fileData} setFileData={setFileData}/>
                                    </div>
                                </div>
                                <div className="col-xl-8">
                                    <div className="card h-auto">

                                        <div className="card-body">
                                            {/*<div className="d-flex justify-content-between mb-4">
                                                <h4 className="card-title text-primary">Edit Profile</h4>
                                            </div>*/}

                                            <div className="alert alert-light border ">
                                                <i className="bi bi-info-circle-fill me-2 text-info"></i>
                                                <span>Keep your contact info and display name up to date so users can recognize you easily.</span>
                                            </div>

                                            {/* Update Profile Form */}
                                            <UpdateProfileForm setToastConfig={setToastConfig} profile={profile} setProfile={setProfile} fileData={fileData} setFileData={setFileData}/>

                                            {/* Change Password Info */}
                                            <hr className="my-4" />
                                            <div className="mt-4">
                                                <h6 className="text-primary">Change Password</h6>
                                                <p className="text-muted mb-2">
                                                    To change your password, please log out and use the "Forgot Password" link to reset it securely.
                                                </p>
                                                {true ?
                                                    <button className="btn btn-outline-primary" onClick={() => window.location.href = "/login"}>
                                                        Logout & Reset Password
                                                    </button> : <></>}
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                </div>
            </div>
        </UserPageLayout>
    );
}